import { ExternalLink } from "@redotech/arbiter/link";
import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { alertOnFailure } from "@redotech/redo-web/alert";
import { COVERAGE_TREATMENT_ID_QUERY_PARAM } from "@redotech/redo-web/utils/shared-conf";
import { memo } from "react";
import { RedoAdminClient } from "../../client";
import { RedoAdminClientContext } from "../../client/context";
import {
  createPreviewTreatment as apiCreatePreviewTreatment,
  getTeam,
} from "../../client/team";
import * as splitCss from "./split-tests.module.css";
import { TreatmentRequest } from "./split-utils";

export async function openTreatmentPreviewInNewTab(
  client: RedoAdminClient,
  teamId: string,
  getTreatment: () => Promise<TreatmentRequest>,
) {
  const currentTeam = await getTeam(client, { teamId });
  if (!currentTeam) {
    return false;
  }
  const treatment = await getTreatment();
  const newTreatment = await apiCreatePreviewTreatment(client, {
    treatment,
    teamId,
  });
  const url = `https://${currentTeam.storeUrl}?${COVERAGE_TREATMENT_ID_QUERY_PARAM}=${newTreatment._id}&preview=true`;
  window.open(url, "_blank");
  return true;
}

export const PreviewButton = memo(function PreviewButton({
  teamId,
  getTreatment,
}: {
  teamId: string;
  getTreatment: () => Promise<TreatmentRequest>;
}) {
  const client = useRequiredContext(RedoAdminClientContext);

  const handlePreview = useHandler(() =>
    alertOnFailure("Creation of preview treatment failed")(async () => {
      await openTreatmentPreviewInNewTab(client, teamId, getTreatment);
    }),
  );

  return (
    <ExternalLink
      className={splitCss.previewLink}
      onClick={handlePreview}
      showIcon={false}
    >
      Preview
    </ExternalLink>
  );
});
